module.exports = __webpack_public_path__ + "static/media/polojenie.4c95560b.pdf";